'use client';
import { createStyles } from '@s7/styles';
import { buttonStylesReset } from '../utils/resetStyles/UnstyledButton.reset.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var useStyles = createStyles(function(theme, param) {
    var contentGap = param.contentGap, stretch = param.stretch, width = param.width;
    return {
        root: _extends({}, buttonStylesReset, {
            width: width ? width : stretch ? "100%" : "fit-content"
        }, width && {
            padding: 0
        }, {
            "& > * + *": {
                marginLeft: theme.fn.space(contentGap)
            }
        }),
        icon: {
            display: "flex",
            boxSizing: "border-box",
            padding: 0
        },
        leftIcon: {},
        rightIcon: {}
    };
});

export { useStyles as default };
